// 'success' 'error' 'warning' 'info'
export default {
  FETCH_USERS: 'fetch_users',
  ONLINE_USERS_CHANGED: 'online_users_changed',
  TYPING_USERS_CHANGED: 'typing_users_changed',
};
